import React, { createContext } from 'react';

const SessionAuthContext = createContext();

export default SessionAuthContext;
